import React, { FC } from "react";
import "react-dates/initialize";
import SearchForm from "./SearchForm";

export type SearchTab = "Open Trip" | "Private Trip";

export interface HeroSearchFormProps {
  className?: string;
  currentTab?: SearchTab;
  currentPage?: "Open Trip" | "Private Trip";
}

const HeroSearchForm: FC<HeroSearchFormProps> = ({
  className = "",
  currentTab = "Open Trip",
  currentPage,
}) => {
  // const tabs: SearchTab[] = ["Open Trip", "Private Trip"];
  // const [tabActive, setTabActive] = useState<SearchTab>(currentTab);

  // const renderTab = () => {
  //   return (
  //     <ul className="ml-6 md:ml-16 xl:ml-20 flex space-x-4 sm:space-x-8 lg:space-x-11">
  //       {tabs.map((tab) => {
  //         const active = tab === tabActive;
  //         return (
  //           <li
  //             onClick={() => setTabActive(tab)}
  //             className={`flex items-center cursor-pointer text-sm lg:text-base font-medium ${active
  //               ? ""
  //               : "text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-100"
  //               } `}
  //             key={tab}
  //           >
  //             {active && (
  //               <span className="block w-2.5 h-2.5 rounded-full bg-neutral-800 dark:bg-neutral-100 mr-2" />
  //             )}
  //             <span>{tab}</span>
  //           </li>
  //         );
  //       })}
  //     </ul>
  //   );
  // };

  const renderForm = () => {
    const isArchivePage = !!currentPage && !!currentTab;
    return <SearchForm haveDefaultValue={isArchivePage} />;
  };

  return (
    <div
      className={`nc-HeroSearchForm w-full  py-5 lg:py-0 ${className}`}
      data-nc-id="HeroSearchForm"
    >
      {/* {renderTab()} */}
      {renderForm()}
    </div>
  );
};

export default HeroSearchForm;
